import { Component } from 'preact';
import { log } from '@/utils';

export default class ErrorBoundary extends Component {
	state = { error: null };

	static getDerivedStateFromError(error) {
		return { error: error.message };
	}

	componentDidCatch(error) {
		log(error);
		this.setState({ error: error.message });
	}

	render() {
		if (this.state.error) {
			return null;
		}
		return this.props.children;
	}
}
